// extracted by mini-css-extract-plugin
export var arrow = "_cd-2";
export var label = "_cd-1";
export var reminder = "_cd-0";